import { Component } from '@angular/core';

@Component({
  selector: 'fl-page-content',
  templateUrl: './page-content.component.html',
  styles: [
  ]
})
export class PageContentComponent {


}
